const PROVIDER_CITATION_PATTERN = /[ \t]*(?:[\s\S]*?|[\s\S]*?)/g;
function findIncompleteCitationStart(text: string): number {
  const citationStart = text.lastIndexOf("cite");
  if (citationStart !== -1 && text.indexOf("", citationStart) === -1) {
    return citationStart;
  }

  const genericStart = text.lastIndexOf("");
  if (genericStart !== -1 && text.indexOf("", genericStart) === -1) {
    return genericStart;
  }

  const midMarkerStart = text.lastIndexOf("");
  if (midMarkerStart === -1 || text.indexOf("", midMarkerStart) !== -1) {
    return -1;
  }

  const citationStartBeforeMidMarker = text.lastIndexOf("cite", midMarkerStart);
  return citationStartBeforeMidMarker === -1 ? midMarkerStart : citationStartBeforeMidMarker;
}

export function stripProviderCitationArtifacts(text: string): string {
  const withoutCompleteMarkers = text.replace(PROVIDER_CITATION_PATTERN, "");
  const incompleteMarkerStart = findIncompleteCitationStart(withoutCompleteMarkers);
  if (incompleteMarkerStart === -1) {
    return withoutCompleteMarkers;
  }

  // Leftover-space cleanup is only valid after slicing an incomplete marker.
  // Stripping on every part would drop the joining space after `:**`, `,`, and `:`.
  return withoutCompleteMarkers.slice(0, incompleteMarkerStart).replace(/[ \t]+$/g, "");
}
